import { Component, Input, OnInit } from '@angular/core';
import { Entity } from '@model/entities/entity';
import { EntityTypeConfig } from '@model/entity-type-config';
import { EntityTypeConfigService } from '@service/entity-type-config.service';
import { StateService } from '@service/state.service';
import { UrlPrettifierService } from '@service/urlPrettifier/url-prettifier.service';

@Component({
  selector: 'contact-button',
  templateUrl: './contact-button.component.html',
  styleUrls: ['./contact-button.component.scss']
})
export class ContactButtonComponent implements OnInit {

  @Input() public hideTextMobile: boolean = false
  @Input() public entity: Entity = null

  constructor(
    private entityTypeConfigService: EntityTypeConfigService,
    public StateService: StateService,
  ) { }

  public ngOnInit() { }

  public click(event: Event) {

    /*
      If it was given an entity its an outer button.
      So go to entity detail state and then write a comment.
    */
    if (this.entity) {
      event.stopPropagation()

      let entityTypeConfig: EntityTypeConfig = this.entityTypeConfigService.getConfigByEntity(this.entity)

      this.StateService.goto(
        entityTypeConfig.detailstate + "/" + this.entity.id + "/" + UrlPrettifierService.prettyUrl(this.entity.title),
        { "scrollToPrivateMessage": true },
        false
      )
    }
  }

}
